//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import SecurityIcon from '@material-ui/icons/Security';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import TextsmsIcon from '@material-ui/icons/Textsms';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';

import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import PhoneInTalkOutlinedIcon from '@material-ui/icons/PhoneInTalkOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
//import ExpandMoreIcon from "@material-ui/core/SvgIcon/SvgIcon";

//import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
//import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import io from 'socket.io-client';
import Divider from "@material-ui/core/Divider";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";



/* const styles = {


};*/

const styles = theme => ({
	margin: {
		margin: theme.spacing.unit * 2,
	},
	extendedIcon: {
		marginRight: theme.spacing.unit * 8,
	},
	card: {
		maxWidth: '100%',
		backgroundColor:'#d5e1eb',
		borderWidth:2,
		borderColor:'black',
		marginBottom:'10px'
	},
	dividerColor1: {
		//marginTop: theme.spacing.unit * 3,
		color:"#40a339",
		backgroundColor:"#40a339",
	},
	
});


//'url(' + require('../../images/IMG_1.JPG')
class ExpandableDispatchInformation extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			age: '',
			name: 'Farshid',
			testnumber: '1232322',
			labelWidth: 0,
			open:false,
		};
		//const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
		this.deleteImageClick = this.deleteImageClick.bind(this);
		this.editImageClick = this.editImageClick.bind(this);
		this.handleClickOpen = this.handleClickOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.PaperComponent = this.PaperComponent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.showPicturesClick = this.showPicturesClick.bind(this);
		
	}
	
	
	deleteImageClick(argData){
		
		//alert('delete was 1 called');
		// this.props.onDelete(argData.id);
		this.setState({ open: true });
		
		
	}
	
	
	
	editImageClick(argData){
		//alert('edit was  1 called');
		/*const { data} = this.props;
		data.forEach((item)=>{item.editMode = false});
		if(argData.editMode){
			if(argData.editMode == true) {

				argData.editMode = false;
			}else{
				argData.editMode = true;
			}
		}else{
			argData.editMode = true;
		}
		*/
		
		this.props.onEdit(argData);
	}
	
	
	vehicleOwnerTextClick(argData){
		
		this.props.onVehicleOwnerText(argData);
	}
	
	towAgentTextClick(argData){
		
		this.props.onTowAgentText(argData);
	}
	
	
	handleClickOpen(){
		this.setState({ open: true });
	};
	
	handleClose(){
		this.setState({ open: false });
	};
	
	handleDelete(){
		this.props.onDelete(this.props.dispatch.id);
		this.setState({ open: false });
	};
	
	PaperComponent(props) {
		return (
			<Draggable cancel={'[class*="MuiDialogContent-root"]'}>
				<Paper {...props} />
			</Draggable>
		);
	}
	
	showPicturesClick(argData) {
		
		this.props.onShowPictures(argData);
	}
	
	
	
	render() {
		const {classes} = this.props;
		var ps = new Date(this.props.dispatch.callDate)  ;
		var hour = ps.getHours() %12;
		var newformat = ps.getHours() >= 12 ? 'PM' : 'AM';
		ps = (ps.getMonth()+1)+"/"+ps.getDate()+"/"+ps.getFullYear() + " " + hour + ":"+ ps.getMinutes()+" "+ newformat;
		
		
		var pdispatchtime = new Date(this.props.dispatch.dispatchdate)  ;
		var hour1 = pdispatchtime.getHours() %12;
		var newformat1 = pdispatchtime.getHours() >= 12 ? 'PM' : 'AM';
		pdispatchtime = (pdispatchtime.getMonth()+1)+"/"+pdispatchtime.getDate()+"/"+pdispatchtime.getFullYear() + " " + hour1 + ":"+ pdispatchtime.getMinutes()+" "+ newformat1;
		
		var statusText = "Unknown";
		if((this.props.dispatch.status != null) && (this.props.dispatch.status != undefined)){
			statusText =this.props.dispatch.status;
		}
		let tempImageSource =  "/static/images/question1.png";
		let barBackgroundColor='#f8fc72';
		//ps = ps ;//  +" Status : " +statusText;
		if( this.props.dispatch.status =='Police') {
			tempImageSource = "/static/images/waiting3.png";
			barBackgroundColor='#0d52db';
		}else if( this.props.dispatch.status =='Waiting') {
			tempImageSource = "/static/images/waiting3.png";
			barBackgroundColor='#e6e3cc';
		}else if(this.props.dispatch.status =='Dispatched'){
			tempImageSource = "/static/images/dispatch2.png";
			barBackgroundColor='#84bf82';
		} else if(this.props.dispatch.status =='Enroute'){
			tempImageSource = "/static/images/enroute1.png";
			barBackgroundColor='#f59e73';
		}else if(this.props.dispatch.status =='Onscene'){
			tempImageSource = "/static/images/onscene.png";
			barBackgroundColor='#f5473b';
		} else if(this.props.dispatch.status =='Towing'){
			tempImageSource = "/static/images/towbrokencar3.png";
			barBackgroundColor='#cc9ef0';
		}else if(this.props.dispatch.status =='Complete'){
			tempImageSource = "/static/images/complete.png";
			barBackgroundColor='#b5d7f5';
		}
		/*
		{this.props.dispatch.plate +" - "+ this.props.dispatch.state + " : " + this.props.dispatch.year+ " - " + this.props.dispatch.make + " - " + this.props.dispatch.model
					+ " - " +this.props.dispatch.color + " - " +this.props.dispatch.vin}
		 */
		/* background color
		#d9b9ed
		#054659
		
		 */
		
		
		return (
			
			< ExpansionPanel  className={classes.card} style={{background: this.props.backgroundColor}}>
				< ExpansionPanelSummary expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
					
					<Grid item xs={1} sm={1} style={{ maxWidth:50,   marginRight:5, backgroundColor:barBackgroundColor}}>
						<img   style={{ marginTop:20, marginLeft:3,color:'white', width:40}} height={40} width={40} src={tempImageSource} />
						< Typography  style={{  color:'#054659', writingMode:'vertical-lr', rotate:'180deg', fontStretch:'ultra-expanded', paddingRight:10, paddingBottom:15, alignSelf:'stretch'  }} variant = "body2" >
							 {this.props.dispatch.status}
						</Typography>
					</Grid>
					
					
					<Grid item xs={8} sm={8}>
						<div>
							< Typography  style={{display: 'inline-block' , color:'#054659'}} variant = "body2" >
								< Typography  style={{display: 'inline-block' , color:'black', fontWeight:'bold'}} variant = "body2" >{this.props.dispatch.dispatchnumber} </Typography>  <br/>
								< Typography  style={{display: 'inline-block' , fontWeight:'bold'}} variant = "body2" > {this.props.dispatch.year} - {this.props.dispatch.make} - {this.props.dispatch.model} - {this.props.dispatch.plate} - {this.props.dispatch.state}</Typography> <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >Vin: </Typography>  {this.props.dispatch.vin} <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" > Call Back Number: </Typography> {this.props.dispatch.callbacknumber } <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" > Po Number: </Typography> {this.props.dispatch.ponumber  } <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >Bill To: </Typography> {this.props.dispatch.billto } <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >Vehicle Type:  </Typography> {this.props.dispatch.vehicletype } <br/>
							< /Typography> <br/>
							< Typography  style={{display: 'inline-block' , color:'#054659'}} variant = "body2" >
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >Location: </Typography> {this.props.dispatch.location} <br/>
								< Typography  style={{display: 'inline-block' , color:'#054659', fontWeight:'bold'}} variant = "body2" >Destination: </Typography> {this.props.dispatch.destination }
							< /Typography>
						</div>
					</Grid>
					<Grid item xs={3} sm={3}>
						<Tooltip title="Tow Status" aria-label="Tow Status">
							< Typography  style={{display: 'inline-block'}} variant = "body2" >
								{ps}
							< /Typography>
						</Tooltip>
					</Grid>
					
					{/*
                            <Grid item xs={1} sm={1}>
                            <Tooltip title="Tow Status" aria-label="Tow Status">

                                < Typography  style={{display: 'inline-block'}}
                            variant = "body2" >
                                Status: Dispatched
                            < /Typography>

                            </Tooltip>
                                </Grid>
                            <Grid item xs={1} sm={1}>

                            </Grid>
                            */}
				
				
				< /ExpansionPanelSummary>
					< ExpansionPanelDetails>
					<Grid container spacing={24}>
					
					
					<Grid item xs={6} sm={6}>
						< Typography   style={{display: 'inline-block' , textDecoration: 'underline' , color:'#9d32a8'}}
						               variant = "subtitle2"
						>
							
							Contact:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block',fontWeight:'fontWeightBold' , color:'black', marginLeft: 15}}
						              variant="caption"
						>
							{"Name: "+this.props.dispatch.name } <br/>
							{"Location: "+this.props.dispatch.location + " - Town: " + this.props.dispatch.town} <br/>
							{"Call back Number: "+ this.props.dispatch.callbacknumber  }
						
						< /Typography>
					</Grid>
					
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline', color:'#9d32a8'}}
						              variant = "subtitle2"
						>
							Fees:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block' ,color:'black',  marginLeft: 15}}
						              variant = "caption"
						>
							{"Quoted: "+this.props.dispatch.amountquoted + ", Method: " + this.props.dispatch.paymentmethod } <br/>
							{"Bill To: "+this.props.dispatch.billto}&nbsp; &nbsp;<br/>
							{ "PO: " + this.props.dispatch.ponumber   } <br/>
							{"Policy: "+this.props.dispatch.policynumber}<br/>{"Claim: " + this.props.dispatch.claimnumber}<br/>
							{"Overage: "+this.props.dispatch.overageamount }
						< /Typography>
					</Grid>
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline',  color:'#9d32a8'}}
						              variant = "subtitle2" >
							Police:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block' , color:'black', marginLeft: 15}}
						              variant = "caption" >
							{/*{this.props.dispatch.policeid}<br/>  */}
							{this.props.dispatch.policedepartmentname}<br/>
						
						
						< /Typography>
					</Grid>
					
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
						              variant = "subtitle2" >
							Dispatch Info:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block' ,color:'black', marginLeft: 15}}
						              variant = "caption" >
							{"Driver: "+this.props.dispatch.driverfirstname+" "+this.props.dispatch.driverlastname} <br/>
							{"Truck: "+this.props.dispatch.trucknumber +" "+ this.props.dispatch.truckmake  +" "+ this.props.dispatch.truckmodel} <br/>
							{"Dispatch: "+pdispatchtime}<br/>{"Dispatcher:  "+ this.props.dispatch.dispatchedby}
						
						< /Typography>
					</Grid>
					
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline' , color:'#9d32a8'}}
						              variant = "subtitle2" >
							Reason:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block',color:'black', marginLeft: 15}}
						              variant = "caption" >
							{this.props.dispatch.towreason}
						< /Typography>
					</Grid>
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
						              variant = "subtitle2" >
							Comment:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block', color:'black', marginLeft: 15}}
						              variant = "caption" >
							{this.props.dispatch.comment}
						< /Typography>
					</Grid>
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
						              variant = "subtitle2" >
							Tow Info:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block', marginLeft: 15, color:'black'}}
						              variant = "caption" >
							{"Unit Size: "+this.props.dispatch.unitsize} &nbsp; &nbsp;{"Unit Number: "+this.props.dispatch.unitnumber}&nbsp;<br/>
							{"Is Truck: "+this.props.dispatch.istruck}&nbsp; &nbsp; {"Loaded: "+ this.props.dispatch.truckloaded}&nbsp; &nbsp;
							{"Height: "+this.props.dispatch.height} &nbsp;  {"Weight: "+this.props.dispatch.totalweight} &nbsp; <br/>
							{"Rear Wheel: "+ this.props.dispatch.dualrearwheel}&nbsp; &nbsp;
							{"Is Trailer: "+this.props.dispatch.istrailer}&nbsp; &nbsp; {"Hookup: "+ this.props.dispatch.hookuptype}&nbsp;<br/>
							{"Ball Size: "+this.props.dispatch.ballsize}&nbsp; &nbsp;
							{"Call: "+this.props.dispatch.calltype}&nbsp; &nbsp;{"Service: "+ this.props.dispatch.servicetype}&nbsp;<br/>
							{"Damage: "+this.props.dispatch.damage}&nbsp; &nbsp;{"Attended: "+ this.props.dispatch.attended}&nbsp; &nbsp; <br/>
							{"Key Location: "+ this.props.dispatch.keylocation}&nbsp; &nbsp;
							{/*
                                        {"P.O: "+this.props.dispatch.ponumber}&nbsp; &nbsp;{"Policy Number: "+ this.props.dispatch.policynumber}&nbsp; &nbsp; */}
						
						< /Typography>
					</Grid>
					
					<Grid item xs={6} sm={6}>
						< Typography  style={{display: 'inline-block', textDecoration: 'underline'  , color:'#9d32a8'}}
						              variant = "subtitle2" >
							Vehicle Info:
						< /Typography>
						<br/>
						< Typography  style={{display: 'inline-block', marginLeft: 15, color:'black'}}
						              variant = "caption" >
							{"VIN: "+this.props.dispatch.vin} &nbsp; &nbsp; <br/>
							{"Year: "+this.props.dispatch.year}&nbsp; &nbsp; <br/>
							{"Model: "+this.props.dispatch.model} &nbsp; <br/>
							{"Make: "+ this.props.dispatch.make}&nbsp; &nbsp; <br/>
							{"Body: "+this.props.dispatch.body}&nbsp; &nbsp;  <br/>
							{"Type: "+this.props.dispatch.type}&nbsp; &nbsp; <br/>
							{"Plate: "+this.props.dispatch.plate}&nbsp; &nbsp; <br/>
							{"State: "+this.props.dispatch.state}&nbsp; &nbsp; <br/>
							
							{/*
                                        {"P.O: "+this.props.dispatch.ponumber}&nbsp; &nbsp;{"Policy Number: "+ this.props.dispatch.policynumber}&nbsp; &nbsp; */}
						
						< /Typography>
					</Grid>
					
					
					
					
					<Grid item xs={12} sm={12}>
						<Divider className={classes.dividerColor1}></Divider>
					</Grid>
					
					<Grid container spacing={24}>
						<Grid item xs={2} sm={2} md={2}  lg={2} >
							<Tooltip title="Edit" aria-label="Edit">
								{/*<IconButton  color="primary" aria-label="edit" className={classes.lowMargin}> */}
								<EditIcon fontSize="large"  onClick={() =>this.editImageClick(this.props.dispatch)}/>
								{/* </IconButton> */}
							</Tooltip>
						</Grid>
						
						<Grid item xs={2} sm={2} md={2}  lg={2}>
							<Tooltip title="Show Disptach Pictures" aria-label="Text">
								<PhotoCameraIcon fontSize="large"   onClick={() => this.showPicturesClick(this.props.dispatch)} />
							</Tooltip>
						</Grid>
						{/*  For now I am commenting these out  so that if I need them later.
                <Grid item xs={1} sm={1}>
                    <Tooltip title="Text Tow Agent Only" aria-label="Text">
                    <img  height={40} width={40} src={tempImageSource}  onClick={() =>this.towAgentTextClick(this.props.dispatch)} />
                    </Tooltip>
                </Grid>

                <Grid item xs={1} sm={1}>
                    <Tooltip title="Text Vehicle Owner" aria-label="Text">
                    <DirectionsCarIcon fontSize="large" onClick={() =>this.vehicleOwnerTextClick(this.props.dispatch)}/>
                </Tooltip>
                </Grid>


                <Grid item xs={3} sm={3}>
                <Tooltip title="Email Status" aria-label="Email Status">
                    < Typography  style={{display: 'inline-block'}}
                        variant = "body2" >
                    Emails: fredi@yahoo.com fredi1@gmail.com someoneelse@alo.com
                < /Typography>
                </Tooltip>
                    </Grid>


                <Grid item xs={5} sm={5}>
                <Tooltip title="Fax Status" aria-label="Fax Status">

                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Fax: 1-800-234-2322
                < /Typography>

                </Tooltip>
                </Grid>
                */}
						
						{/*
                <Grid item xs={2} sm={2}>

                <Tooltip title="Tow Status" aria-label="Tow Status">

                    < Typography  style={{display: 'inline-block'}}
                variant = "button" >
                    Status: Complete
                < /Typography>

                </Tooltip>

                    </Grid>
                    */}
					</Grid>
				</Grid>
			
			< /ExpansionPanelDetails>
	< /ExpansionPanel>
	
	)
		;
	}//end of render
}//End of class

ExpandableDispatchInformation.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpandableDispatchInformation);
